module.exports = __webpack_public_path__ + "static/media/providers-import.ec0f8f79.csv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/providers-import.csv
// module id = ./src/assets/providers-import.csv
// module chunks = 11